

// To get the value with unit | usage = GetValueWithUnit(10) = 10px
export const GetValueWithUnit = value => {
  if (!value) return null;
  if (['function', 'object', 'undefined'].includes(typeof value) && value) return console.warn("Pass either a string or a number unit in 'GetValueWithUnit' function");;
  if (typeof value === "number") return `${value}px`;
  return value;
};